import React, { useState, useEffect } from 'react';
import { Typography } from '@material-ui/core';

import SurveyForm from 'components/views/surveys/form';
import { NEW_SURVEY } from 'data/surveys';
import useStyles from './CreateSurvey.styles';
import { tenantHandler } from 'services/shared/handlers'

const flagsValues = {
  'condition_day': { unnecessaryFields: [] },
  'rules_based': { unnecessaryFields: ['dayCondition'] }
}

const CreateSurvey = ({ actions, tenants }) => {
  const classes = useStyles();
  const [form, setForm] = useState(NEW_SURVEY);

  useEffect(() => {
    actions.onMount();
    return () => actions.onUnmount();
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    let newTenants = tenants.tenants.map(tenant => tenant.id)
    setForm({
      ...form,
      tenants:newTenants
    })
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tenants]);

  const handleChange = name => ({ target: { value } }) => {
    setForm({
      ...form,
      [name]: value
    });
  };

  const handleTenantCheck = (tenantIndex) => ({ target }) => {
    tenantHandler(tenantIndex, target, form, tenants, setForm);
  };

  const handleSubmit = () => {
    const { unnecessaryFields } = flagsValues[form.flags];
    unnecessaryFields.forEach(field => handleChange(field)({ target: { value: '' } }));
    actions.createSurvey(form);
  };

  return (
    <div className={classes.pageContainer}>
      <Typography variant="h5">Create Survey</Typography>
      <SurveyForm
        handleChange={handleChange}
        form={form} onSubmit={handleSubmit}
        tenants={tenants}
        handleTenantCheck={handleTenantCheck}
      />
    </div>
  );
};

export default CreateSurvey;
